export default function(H) {
    H.setOptions({
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        }
    });
  }
